import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { useWatch } from 'react-hook-form';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.FractionDigits}`;
const integerFieldName = `rules.${RuleType.Integer}.value`;

export interface IFractionDigitsRuleComponentProps {}

export function FractionDigitsRuleComponent(
  props: IFractionDigitsRuleComponentProps,
) {
  const isInteger = useWatch({ name: integerFieldName });

  if (isInteger) return null;

  return (
    <FormItem
      name={`${fieldName}.value`}
      label="Numero massimo di cifre decimali"
      help={
        <>
          Il <b>Numero massimo di cifre decimali</b> segnala un errore di
          validazione se il valore inserito ha più decimali del massimo; il
          messaggio è personalizzabile. Per limitare direttamente la digitazione
          usare «Numero massimo cifre decimali» nella card «Default e
          Compilazione».
        </>
      }
    >
      <$SpaceCompact block size="large">
        <NumberInput name={`${fieldName}.value`} />
        <CustomValidationRuleMessage name={`${fieldName}.customMessage`} />
      </$SpaceCompact>
    </FormItem>
  );
}
